// eslint-disable-next-line import/prefer-default-export
export const getBase64 = (img: File, callback: (file: string) => void): void => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result as string));
  reader.readAsDataURL(img);
};
